<div class="page_wrapper">
  <app-header-new></app-header-new>
  <div class="container-fluid wrapper-page header-fix position-relative display-contents">
    <div class="container mt-5">
      <div class="row justify-content-center ">
        <div class="col-md-5">
          <img src="/assets/images/sign-in.png" class="w-100" />
        </div>
        <div class="col-md-2"></div>
        <div class="col-md-5 mt-4 mt-md-0">
          <p class="text-color font-size-30 font-weight-500">WELCOME BACK,</p>
          <p class="text-change font-size-20 font-weight-500">Sign in to your account to continue...</p>
          <form #loginForm="ngForm">
            <div *ngIf="!isSuperAdmin">
              <div class="form-check form-check-inline">
                <input class="form-check-input" type="radio" [(ngModel)]="user['account_type']"
                  [ngModelOptions]="{standalone: true}" id="inlineRadio1" value="patient">
                <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio1">Patient</label>
              </div>
              <div class="form-check form-check-inline ml-5">
                <input class="form-check-input" type="radio" [(ngModel)]="user['account_type']"
                  [ngModelOptions]="{standalone: true}" id="inlineRadio2" value="healthcare_provider">
                <label class="form-check-label font-size-15 font-weight-500" for="inlineRadio2">Healthcare
                  Provider</label>
              </div>
            </div>
            <div [innerHTML]="innerHtml" class="text-center"> </div>
            <div class="form-group inputWithIcon position-relative">
              <input required [(ngModel)]="user['email_id']" name="email_id" #email_id="ngModel" type="text"
                placeholder="Email Address/Username" class="form-control ">
              <i class="fa fa-lock text-color-font fa-lg position-absolute"></i>
              <div class="alert alert-danger" *ngIf="email_id.touched && !email_id.valid">
                <img src="assets/images/icon-alert.png" class="img-size "> Please Enter Email Id
              </div>
            </div>

            <div class="form-group inputWithIcon position-relative">
              <input required [(ngModel)]="user['password']" name="password" #password="ngModel"
                [type]="isMutePass?'text':'password'" placeholder="Password" class="form-control ">
              <i class="fa text-color-font fa-lg position-absolute cursor"
                [ngClass]="{'fa-eye': isMutePass, 'fa-eye-slash': !isMutePass }" (click)="isMutePass = !isMutePass"></i>
              <div class="alert alert-danger" *ngIf="password.touched && !password.valid">
                <img src="assets/images/icon-alert.png" class="img-size"> Please Enter Password
              </div>
            </div>
            <div class="d-flex">
              <div class="col-md-6">
                <div class="form-group form-check">
                  <input type="checkbox" name="checkbox1" value="true" class="form-check-input" [(ngModel)]="rememberMe"
                    [ngModelOptions]="{standalone: true}" id="checkbox1" (change)="rememberMeChecked($event)">
                  <label class="form-check-label text-change font-size-17 font-weight-400" for="rememberMe">Remember
                    Me</label>
                </div>
              </div>
              <div class="col-md-6">
                <p class="text-right ml-3 w-100 text-color font-size-17 font-weight-500 ">
                  <a routerLink="/forgotpassword" routerLinkActive="active">Forgot Password</a>
              </div>
            </div>

            <button type="submit" [disabled]="!loginForm.valid" (click)="authUser()"
              class="btn btn-primary w-100 mt-4">SIGN IN</button>
            <p class="text-center mt-4 text-change font-size-17">Don’t have an account?
              <span class="link">
                <a routerLink="/register" routerLinkActive="active">Create Account </a>
              </span>

          </form>
        </div>
      </div>

    </div>
  </div>
  <app-footer-new></app-footer-new>
</div>